import React, { useContext } from 'react';
export const actionColumnDef = {
  width: 40
};
export const expandIconStyle = {
  width: 24
};
export const TableListContext = /*#__PURE__*/React.createContext({
  columnDefs: [],
  expandedRows: {},
  selectedRows: {},
  numRows: 0,
  numSelectedRows: 0,
  hPadding: 'm',
  onToggleAllSelection: _selected => {},
  toggleExpandedRow: state => state,
  setSelectedRows: state => state,
  setSort: state => state,
  expandAllRows: _isAllExpanded => {},
  registerRow: _ref => {
    let {
      rowId: _rowId,
      isExpanded: _isExpanded
    } = _ref;
  },
  unregisterRow: _rowId => {}
});
export const useTableListContext = () => useContext(TableListContext);